export const PRODUCTS_BETA_FEATURE = 'product_database'
